var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgApproved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.62 2.489.326.248.406-.052 2.02-.257.787 1.877.158.378.377.158 1.878.787-.257 2.02-.052.406.248.326L18.744 10l-1.233 1.62-.248.326.052.406.257 2.02-1.877.787-.378.158-.158.377-.787 1.878-2.02-.257-.406-.052-.326.248L10 18.744 8.38 17.51l-.326-.248-.406.052-2.02.257-.787-1.877-.158-.378-.378-.158-1.877-.787.257-2.02.052-.406-.248-.326L1.256 10 2.49 8.38l.248-.326-.052-.406-.257-2.02 1.877-.787.378-.158.158-.378.787-1.877 2.02.257.406.052.326-.248L10 1.256l1.62 1.233Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.125 13.563 6 10.463l.994-.982 2.131 2.113L13.756 7l.994.987-5.625 5.575Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/approved.991a64a7c7ac18be1b1267d5cc435f35.svg";